"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSvg = void 0;
const utility_paths_1 = require("./paths/utility.paths");
const paths_1 = require("./paths");
const types_paths_1 = require("./paths/types.paths");
const svgpath_1 = __importDefault(require("svgpath"));
function GetSvg(shape, pathProperties, viewBox) {
    let svg = '';
    const { strokeWidth } = utility_paths_1.getNormalizedStrokeProperties(pathProperties.stroke);
    switch (shape.type) {
        case types_paths_1.ShapeTypes.Polygon:
        case types_paths_1.ShapeTypes.StarBurst:
        case types_paths_1.ShapeTypes.Arrow:
        case types_paths_1.ShapeTypes.DoubleSidedArrow:
        case types_paths_1.ShapeTypes.CircularSpeechBubble:
        case types_paths_1.ShapeTypes.SpeechBubble: {
            const path = paths_1.GetPath(shape, pathProperties);
            const pathData = paths_1.GetPathData(shape);
            const transformPathData = pathProperties.transform
                ? svgpath_1.default(pathData).transform(pathProperties.transform).toString()
                : pathData;
            const defaultViewBox = utility_paths_1.getViewBox({ paths: [transformPathData], strokeWidth });
            const svgViewBox = viewBox || defaultViewBox;
            svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${svgViewBox}">${path}</svg>`;
            break;
        }
        case types_paths_1.ShapeTypes.Rectangle: {
            const defaultViewBox = utility_paths_1.getViewBox({ dimensions: { width: shape.width, height: shape.height }, strokeWidth });
            const svgViewBox = viewBox || defaultViewBox;
            const pathHtmlAttributes = utility_paths_1.generateHtmlAttributesFromPathProperties(pathProperties);
            // eslint-disable-next-line max-len
            svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${svgViewBox}"><rect width="${shape.width}" height="${shape.height}" ${pathHtmlAttributes} /></svg>`;
            break;
        }
        case types_paths_1.ShapeTypes.Ellipse: {
            const defaultViewBox = utility_paths_1.getViewBox({ dimensions: { width: shape.width, height: shape.height }, strokeWidth });
            const svgViewBox = viewBox || defaultViewBox;
            const pathHtmlAttributes = utility_paths_1.generateHtmlAttributesFromPathProperties(pathProperties);
            svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${svgViewBox}"><ellipse cx="${shape.width / 2}" cy="${shape.height / 2}" rx="${shape.width / 2 - strokeWidth}" ry="${shape.height / 2 - strokeWidth}" ${pathHtmlAttributes} /></svg>`;
            break;
        }
        case types_paths_1.ShapeTypes.Line: {
            const defaultViewBox = utility_paths_1.getViewBox({ dimensions: { width: shape.width, height: shape.height }, strokeWidth });
            const svgViewBox = viewBox || defaultViewBox;
            const pathHtmlAttributes = utility_paths_1.generateHtmlAttributesFromPathProperties(pathProperties);
            svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${svgViewBox}"><line x1="0" y1="${shape.height / 2}" x2="${shape.width}" y2="${shape.height / 2}" ${pathHtmlAttributes} /></svg>`;
            break;
        }
    }
    return svg;
}
exports.GetSvg = GetSvg;
//# sourceMappingURL=getSvg.js.map